import { Dialog, DialogPanel, DialogTitle, DialogBackdrop } from '@headlessui/react'
import { BlackActionButton } from '../buttons/BlackActionButton'

interface IConfirmationDialogProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  title: string
  content: string
  confirmLabel?: string
  cancelLabel?: string
}

export const ConfirmationDialog = (props: IConfirmationDialogProps) => {
  const {
    isOpen,
    onClose,
    onConfirm,
    title,
    content,
    confirmLabel = 'Confirm',
    cancelLabel = 'Cancel'
  } = props

  const handleConfirm = () => {
    onConfirm()
    onClose()
  }

  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      <DialogBackdrop className="fixed inset-0 bg-black/30" />
      
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <DialogPanel className="w-full max-w-md rounded-2xl bg-white p-6 shadow-xl">
          <DialogTitle className="text-lg font-semibold text-gray-900">
            {title}
          </DialogTitle>
          
          <div className="mt-3 text-gray-600">
            {content}
          </div>

          <div className="mt-6 flex justify-end gap-3">
            <button
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-gray-700 hover:text-gray-900 cursor-pointer"
            >
              {cancelLabel}
            </button>
            <div onClick={handleConfirm}>
              <BlackActionButton label={confirmLabel} />
            </div>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  )
}
